import {useMemo} from 'react';
import {PhoneDetails} from '@chekin/core';
import {useGuestGroup} from 'hooks';

const EMPTY_PHONE: PhoneDetails = {code: '', number: ''};

export function useDefaultContactData() {
  const {guestGroup} = useGuestGroup();

  return useMemo(() => {
    const isLeadVerified = !!guestGroup?.is_leader_contact_verified;
    const isLeaderGuest = !guestGroup?.added_number_of_guests;

    return {
      email: '',
      phone: EMPTY_PHONE,
      isLeadVerified,
      isLeaderGuest,
    };
  }, [guestGroup]);
}
